import React from "react";
import "../index.css";
import backgroundUrl from "../../../img/about/crypto-defi-trading-multi-chain-ecyosystem-background.svg";
import backgroundMobileUrl from "../../../img/about/mobile/Mobiile_ColouredBackgrounds_EthPoly.svg";
import backgroundTabletUrl from "../../../img/about/tablet/Tablet_ColouredBackgrounds_EthPolygon.svg";
import Feature4Img from "../../../img/about/crypto-defi-trading-multi-chain-ethereum-polygon.png";
import { FeatureImage as FeatureImageOriginal } from "./elements/FeatureImage";
import { SectionDescription } from "./elements/SectionDescription";
import styled from "@emotion/styled";
import { SectionContainer } from "./elements/SectionContainer";
import { SectionTitle } from "./elements/SectionTitle";
import { FlexBetweenContainer } from "containers/FlexBetweenContainer";

export interface Feature4Props {
  className?: string;
}

export const Feature4: React.FC<Feature4Props> = () => {
  return (
    <Section>
      <FlexBetweenContainer direction="column">
        <FeatureImage src={Feature4Img} alt="feature-4" />
        <SectionTitle>Trade on multiple blockchains</SectionTitle>
        <SectionDescription>
          Competitive rates across multiple blockchains. Trade on Ethereum, Polygon, and Arbitrum,
          with more integrations to come!
        </SectionDescription>
      </FlexBetweenContainer>
    </Section>
  );
};

// Sub-components

const Section = styled(SectionContainer)(() => ({
  backgroundImage: `url(${backgroundUrl})`,
  marginTop: "115px",
  height: "100%",

  "@media screen and (min-width: 1024px) and (max-width: 1280px)": {
    backgroundSize: "100vw",
  },

  "@media screen and (min-width: 390px) and (max-width: 768px)": {
    backgroundImage: `url${backgroundTabletUrl}`,
    backgroundSize: "100vw",
  },

  "@media screen and (max-width: 390px)": {
    backgroundImage: `url(${backgroundMobileUrl})`,
    backgroundSize: "100vw",
  },
}));

const FeatureImage = styled(FeatureImageOriginal)(() => ({
  width: "28.3%",
  margin: "26.7% auto 0",
  marginBottom: "60px",

  "@media screen and (min-width: 390px) and (max-width: 768px)": {
    marginTop: "36%",
    width: "40%",
  },
  "@media screen and (min-width: 390px) and (max-width: 501px)": {
    width: "42%",
    marginTop: "27%",
  },
  "@media screen and (max-width: 390px)": {
    width: "67%",
    marginTop: "62%",
  },
}));
